export const getUserData = () => {
  let mopUser = {};

  try {
    mopUser = JSON.parse(localStorage.getItem("mop-user"));
  } catch (error) {}

  return mopUser;
};
